import { Persona } from '@localStorage/domain/models/Persona'
import { User } from '@localStorage/domain/models/User'
import { LocalStorageRepository } from '@localStorage/domain/repositories/LocalStorageRepository'

import { localStorageDatasource } from '.'
import { localStorageRepositoryAdapter } from '.'
import { OccurrencesFilter } from './domain/models/OccurrencesFilter'
import { SessionManagementFilter } from './domain/models/SessionManagementFilter'

export * from '@localStorage/external/localStorageAdapter'
export * from '@localStorage/infra/datasource/localStorageRepositoryAdapter'

export const localStorageInstance = LocalStorage(
  localStorageRepositoryAdapter(localStorageDatasource)
)

export function LocalStorage(repository: LocalStorageRepository) {
  return {
    getUser: (): User | null => {
      try {
        return repository.getUser()
      } catch {
        return null
      }
    },

    setUser: (user: User) => {
      repository.setUser(user)
    },

    deleteUser: () => {
      repository.deleteUser()
    },

    getPersona: (): Persona | null => {
      try {
        return repository.getPersona()
      } catch {
        return null
      }
    },

    setPersona: (persona: Persona) => {
      repository.setPersona(persona)
    },

    deletePersona: () => {
      repository.deletePersona()
    },

    getSessionManagementFilter: (): SessionManagementFilter | null => {
      try {
        return repository.getSessionManagementFilter()
      } catch {
        return null
      }
    },

    setSessionManagementFilter: (filter: SessionManagementFilter) => {
      repository.setSessionManagementFilter(filter)
    },

    deleteSessionManagementFilter: () => {
      repository.deleteSessionManagementFilter()
    },
    getOccurrencesFilter: (): OccurrencesFilter | null => {
      try {
        return repository.getOccurrencesFilter()
      } catch {
        return null
      }
    },

    setOccurrencesFilter: (filter: OccurrencesFilter) => {
      repository.setOccurrencesFilter(filter)
    },

    deleteOccurrencesFilter: () => {
      repository.deleteOccurrencesFilter()
    },

    clear: () => {
      repository.clear()
    }
  }
}
